import React from 'react';
import PropTypes from 'prop-types';
import WebsiteSubscriptionCenterPage from 'website-subscription-center-page';
import SubscriptionCenterWidget from 'auth0-subscription-center-widget';

const SubscriptionCenter = ({ email }) =>
  <WebsiteSubscriptionCenterPage email={email}>
    <SubscriptionCenterWidget apiUrl="https://dwh-tracking.it.auth0.com" />
  </WebsiteSubscriptionCenterPage>;

SubscriptionCenter.propTypes = {
  email: PropTypes.string
};

export default SubscriptionCenter;



// WEBPACK FOOTER //
// ./src/pages/subscription-center/containers/SubscriptionCenter/SubscriptionCenter.js